import { apiClient } from './client';
import type {
  Establishment,
  CreateEstablishmentData,
  UpdateEstablishmentData,
} from '@/types/school';

export async function getEstablishments(schoolCode: string): Promise<Establishment[]> {
  const response = await apiClient.get<{ data: Establishment[] }>(
    `/api/schools/${schoolCode}/establishments`
  );
  return response.data.data;
}

export async function createEstablishment(
  schoolCode: string,
  data: CreateEstablishmentData
): Promise<Establishment> {
  const response = await apiClient.post<{ data: Establishment }>(
    `/api/schools/${schoolCode}/establishments`,
    data
  );
  return response.data.data;
}

export async function updateEstablishment(
  schoolCode: string,
  id: number,
  data: UpdateEstablishmentData
): Promise<Establishment> {
  const response = await apiClient.put<{ data: Establishment }>(
    `/api/schools/${schoolCode}/establishments/${id}`,
    data
  );
  return response.data.data;
}

export async function deleteEstablishment(schoolCode: string, id: number): Promise<void> {
  await apiClient.delete(`/api/schools/${schoolCode}/establishments/${id}`);
}

export async function importV1Establishments(
  schoolCode: string
): Promise<{ message: string; imported: number; skipped: number; establishments: Establishment[] }> {
  const response = await apiClient.post<{
    message: string;
    imported: number;
    skipped: number;
    establishments: Establishment[];
  }>(`/api/schools/${schoolCode}/establishments/import-v1`);
  return response.data;
}

export async function syncEstablishmentsV2(
  schoolCode: string
): Promise<{ message: string; establishments: Establishment[] }> {
  const response = await apiClient.post<{ message: string; establishments: Establishment[] }>(
    `/api/schools/${schoolCode}/establishments/sync-v2`
  );
  return response.data;
}
